module.exports = __webpack_public_path__ + "img/U30USD.7d5d6822.png";